import { appRoutesUtils } from "./app-routes-utils"

export const UrlUtils = {
  getUrl : (params, route) => {
    if(route){
      return appRoutesUtils.getRoute(params) + route
    }
    return "https://www.google.com.br"
  },
  getLocation : ()=> {
    return window.location
  },
  getParam : (paramName, urlSearchParams=null) =>{
    return (urlSearchParams || new URLSearchParams(window.location.search)).get(paramName)
  },
  redirect : (url) => {
    window.location.replace(url);
  }
}